module.exports = __webpack_public_path__ + "static/img/jdy5.f91ae84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jdy5.png
// module id = 74D+
// module chunks = 0